import { render, staticRenderFns } from "./opportunityDeskView.vue?vue&type=template&id=64e35dc8&scoped=true"
import script from "./opportunityDeskView.vue?vue&type=script&lang=js"
export * from "./opportunityDeskView.vue?vue&type=script&lang=js"
import style0 from "./opportunityDeskView.vue?vue&type=style&index=0&id=64e35dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e35dc8",
  null
  
)

export default component.exports